import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ImageCroppedEvent, ImageCropperComponent } from 'ngx-image-cropper';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { UntypedFormControl } from '@angular/forms';
import { ImgAspectRatioType } from '../../../types/misc';
import { ASPECT_RATIO, ICONS } from '../../../constants/constants';

@Component({
  selector: 'app-img-crop',
  templateUrl: './img-crop.component.html',
  styleUrls: ['./img-crop.component.scss'],
})
export class ImgCropComponent implements OnInit {
  public imgChangeEvt: Event | undefined;
  public src: SafeUrl | undefined;
  public file: File | undefined;
  public tmpFile: ImageCroppedEvent | undefined;
  public showImgCropper: boolean = false;

  protected readonly ICONS = ICONS;

  @ViewChild('input') input: ElementRef<HTMLInputElement>;
  @ViewChild('imageCropper') imageCropper: ImageCropperComponent;

  @Input() public fc: UntypedFormControl;
  @Input() public aspectRatio: ImgAspectRatioType = ASPECT_RATIO.LOGO;
  @Input() public alt: string = '';

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.fc.valueChanges.subscribe((src: string | File | null = '') => {
      if (typeof src === 'string') {
        this.src = this.sanitizer.bypassSecurityTrustUrl(src);
      } else if (src === null) {
        this.src = '';
      }
    });
  }

  public onUploadImgClick(): void {
    this.input.nativeElement.click();
  }

  onFileChange(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];

    if (!file) {
      return;
    }

    this.file = file;
    this.imgChangeEvt = event;
    this.showImgCropper = true;
  }

  imageCropped(e: ImageCroppedEvent): void {
    this.tmpFile = e;
  }

  showCropImg(): void {
    this.showImgCropper = false;

    this.src = this.sanitizer.bypassSecurityTrustUrl(
      this.tmpFile?.objectUrl ?? ''
    );
    this.input.nativeElement.value = '';

    if (this.tmpFile?.blob) {
      const fileName = new Date().getTime().toString();
      const file = new File([this.tmpFile.blob], fileName, {
        lastModified: this.file?.lastModified,
        type: this.file?.type,
      });

      this.fc.setValue(file);
    }
  }

  cancelEdit(): void {
    this.showImgCropper = false;
    this.input.nativeElement.value = '';
  }

  get dynamicStyles(): Record<string, string | number> {
    return {
      'aspect-ratio': this.aspectRatio,
    };
  }
}
